import React from "react";
import { STPinButton } from "./styles";

interface IProps {
  onClick: (digin: number) => void;
  digit: number;
}

export default class DigitButton extends React.Component<IProps> {
  handleClick = (e: any) => {
    this.props.onClick(this.props.digit);
  };

  render() {
    return (
      <STPinButton variant="outlined" fullWidth onClick={this.handleClick}>
        {this.props.digit}
      </STPinButton>
    );
  }
}
